/* eslint-disable */

//tslint:disable

import { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api/shared/http';
import {
  TGetUserTypeModel,
  IGetUserTypeRequest,
  IMappers,
  IGetUserTypeResponse,
  IGetUserTypeResponseError,
  TGetUserTypeResponse,
} from './types';

const defaultConfig: TGetUserTypeModel = {
  apiType: 'private',
  assertStatusCodes: [200, 400],
  method: 'GET',
  microserviceName: 'homeowners',
  pathApi: '/v1/get-user-type/',
  hostType: 'api',
} as TGetUserTypeModel;

function createGetUserTypeModel(parameters: IGetUserTypeRequest): TGetUserTypeModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface IGetUserTypeOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  parameters: IGetUserTypeRequest;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
}

async function fetchGetUserType<TResponse200, TResponse400>({
  httpApi,
  parameters,
  config,
  mappers,
}: IGetUserTypeOptions<TResponse200, TResponse400>): Promise<TResponse200 | TResponse400 | TGetUserTypeResponse> {
  const { response, statusCode } = await httpApi.fetch(createGetUserTypeModel(parameters), config);

  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IGetUserTypeResponse);
    }

    if (statusCode === 400) {
      return mappers[400](response as IGetUserTypeResponseError);
    }
  }

  return { response, statusCode } as TGetUserTypeResponse;
}

export { defaultConfig, createGetUserTypeModel, fetchGetUserType };
